import React, { useContext, useEffect, useState } from 'react';
import "../../styles/bootstrap.css"
import "../../styles/style.css"
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../App';
import { baseURL } from '../../token';
import axios from 'axios';

import Logo from '../Logo';
import { handleUnAuthorized } from '../hooks/handleUnAuthorized';
function UserSection() {

    // const { user } = useContext(AuthContext);
    const [user, setUser] = useState('');
    const navigate = useNavigate();
    const menuItemStyle = {
        fontSize: '18px',
        fontWeight: 500,
        letterSpacing: '0.1px',
    };

    const menuIconStyle = {
        fontSize: '26px',
        width: '24px',
        textAlign: 'center',
        color: '#111827',
    };

    const menuIconChipStyle = {
        width: '34px',
        height: '34px',
        borderRadius: '10px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        flexShrink: 0,
    };

    const menuArrowStyle = {
        fontSize: '22px',
        flexShrink: 0,
        color: '#111827',
    };

    const menuItems = [
        { label: 'Profile', icon: 'account_circle', path: '/ProfilePage' },
        { label: 'Play', icon: 'casino', path: '/PlayPage' },
        { label: 'Wallet', icon: 'wallet', path: '/WalletPage' },
        { label: 'History', icon: 'history', path: '/HistoryPage/2' },
        { label: 'Transaction History', icon: 'history', path: '/HistoryPage/1' },
        { label: 'Deposit History (Auto)', icon: 'history', path: '/UpiGatewayHistoryPage' },
        { label: 'Support', icon: 'support_agent', path: '/SupportPage' },
        { label: 'Legal Terms', icon: 'gavel', path: '/LegalPage' },
        { label: 'Refer & Earn', icon: 'offline_share', path: '/share' },
    ];

    const fetchdata = async () => {
        try {
            const accessToken = localStorage.getItem('access_token');
            const headers = accessToken ? { Authorization: `Bearer ${accessToken}` } : {};

            const responsedetail = await axios.get(baseURL + '/me', {
                headers: headers,
            });

            const responseData = responsedetail.data;
            setUser(responseData);
        } catch (e) {
            if (e.response.status == 401) {
                handleUnAuthorized(e.response.status, navigate)
            }
        }
    }
    useEffect(() => {
        fetchdata();

        // Set up a polling interval (e.g., every 5 seconds)
        // const intervalId = setInterval(fetchdata, 5000);

        // // Clean up the interval on component unmount
        // return () => clearInterval(intervalId);
    }, [])

    return (
        <>

            <section id="main-bg">
                <div id="navbar-container" className=" mx-0">
                    <div className="row">
                            <div className="bg-dark p-2 offcanvas-header">
                                <div className="text-white offcanvas-title h5">Redbullludo</div>
                                <button type="button" className="btn-close btn-close-white" aria-label="Close" onClick={() => navigate('/PlayPage')}></button>
                            </div>
                        {/* <div className="col-12 d-flex align-items-center justify-content-end pe-0" id="nav-head">
                            <div id="profile-img-bg" className="rounded-circle">
                                <img src="./images/img.jpg" className="rounded-circle" style={{ width: '100%' }} alt />
                            </div>
                            
                            <div id="profile-info-bg">
                                <h5 style={{ textTransform: "capitalize" }} className=" text-light pt-2 mb-0 ms-5">{user?.name}</h5>
                                <p className="text-light text-white ms-5 mb-0">{user?.Name}</p>
                                <p className="text-light text-white ms-5 mb-0">{user?.Phone}</p>
                                <p className="text-light text-white ms-5 mb-1">{user?.Email}</p>
                                <h6 className="text-light ms-5 rounded-pill " id="profile-id">{user?.email}</h6>
                            </div>
                        </div> */}
                            <div className="d-flex align-items-center justify-content-between p-4">
                                <div className="d-flex align-items-center">
                                    <div className="fs-1 fw-bold text-start d-flex align-items-center justify-content-start">
                                        <div className="d-flex align-items-center justify-content-start gap-2">
                                            <span className="m-0">{user?.Name}</span>
                                            <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M23 17c0 3.31-2.69 6-6 6v-1.5c2.48 0 4.5-2.02 4.5-4.5H23zM1 7c0-3.31 2.69-6 6-6v1.5C4.52 2.5 2.5 4.52 2.5 7H1zm7.01-2.68-4.6 4.6c-3.22 3.22-3.22 8.45 0 11.67s8.45 3.22 11.67 0l7.07-7.07c.49-.49.49-1.28 0-1.77a1.25 1.25 0 0 0-1.77 0l-4.42 4.42-.71-.71 6.54-6.54c.49-.49.49-1.28 0-1.77s-1.28-.49-1.77 0l-5.83 5.83-.71-.71 6.89-6.89c.49-.49.49-1.28 0-1.77s-1.28-.49-1.77 0l-6.89 6.89-.69-.7 5.48-5.48c.49-.49.49-1.28 0-1.77s-1.28-.49-1.77 0l-7.62 7.62a4.003 4.003 0 0 1-.33 5.28l-.71-.71a3 3 0 0 0 0-4.24l-.35-.35 4.07-4.07c.49-.49.49-1.28 0-1.77a1.27 1.27 0 0 0-1.78.01z"></path></svg>
                                        </div>
                                    </div>
                                </div>
                                <a href="/ProfilePage">
                                    <div className="rounded-circle bg-dark d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px' }}>
                                        <img src="./images/img.jpg" alt="avatar" style={{ width: '100%', borderRadius: '50%' }} />
                                    </div>
                                </a>
                            </div>
                            

                        {menuItems.map((item) => (
                            <div
                                key={item.path}
                                onClick={() => navigate(item.path)}
                                className="col-12 d-flex align-items-center justify-content-between text-light px-3 py-3 nav-item"
                            >
                                <div className="d-flex align-items-center gap-3">
                                    <span className="material-symbols-outlined" style={menuIconChipStyle}>
                                        <span style={menuIconStyle}>{item.icon}</span>
                                    </span>
                                    <h4 className="mb-0" style={menuItemStyle}>{item.label}</h4>
                                </div>
                                <div className="d-flex align-items-center">
                                    <svg
                                        stroke="currentColor"
                                        fill="currentColor"
                                        strokeWidth="0"
                                        viewBox="0 0 24 24"
                                        height="1em"
                                        width="1em"
                                        xmlns="http://www.w3.org/2000/svg"
                                        style={menuArrowStyle}
                                    >
                                        <path fill="none" d="M0 0h24v24H0V0z"></path>
                                        <path d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z"></path>
                                    </svg>
                                </div>
                            </div>
                        ))}

                    </div>
                </div>
                <div className="" style={{ position: 'fixed', top: '50%', left: 'calc(100% - 40%)', transform: `translate(-50%,-50%)`, zIndex: 5 }}>
                    <div className="rcBanner flex-center">
                        <Logo />
                        {/* <picture className="rcBanner-img-containerr">
                            <img style={{ marginLeft: '10px', width: "80% ", borderRadius: '50%' }} src="./images/Ludolkjpg.jpg" alt />
                        </picture>
                        <div className="rcBanner-text">Play Ludo &amp; <span className="rcBanner-text-bold">Win Real Cash!</span></div>
                        <div className="rcBanner-footer">For best experience, open&nbsp;<a href="/">ludokavish.com</a>&nbsp;on&nbsp;&nbsp;chrome </div> */}
                    </div>

                </div>
            </section>
        </>

    )
}

export default UserSection;